import { useQuery } from "@tanstack/react-query";
import { transactionApi } from "../../api";
import { paymentQueryKeys } from "./paymentQueryKeys";

/** Platform-only configuration for adding a card without a facility. */
export function useWalletFrontendConfig() {
  return useQuery({
    queryKey: paymentQueryKeys.walletFrontendConfig(),
    queryFn: () => transactionApi.getWalletFrontendConfig(),
    retry: false,
  });
}
